module.exports = __webpack_public_path__ + "static/media/TN-Women-Dress.5eae7897.svg";